import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaArrowDown, FaClock, FaBook, FaCheckCircle, FaFire } from 'react-icons/fa';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import config from '../../config';

//const API_BASE_URL = 'http://localhost:3001/api/study-tools';
const API_BASE_URL = `${config.API_BASE_URL}/api/study-tools`;

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalStudyTime: 0,
    subjectsCovered: 0,
    tasksCompleted: 0,
    currentStreak: 0,
    subjectsTrend: 0,
    tasksTrend: 0,
    studyTimeTrend: 0
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [upcomingTasks, setUpcomingTasks] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/analytics`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        const analyticsData = response.data;
        setStats({
          totalStudyTime: analyticsData.totalStudyHours,
          subjectsCovered: analyticsData.subjectDistribution ? analyticsData.subjectDistribution.length : 0,
          tasksCompleted: analyticsData.completedTasks,
          currentStreak: analyticsData.currentStreak,
          subjectsTrend: analyticsData.subjectTrend,
          tasksTrend: analyticsData.taskTrend,
          studyTimeTrend: analyticsData.studyTimeTrend
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Fallback to mock data
        setStats({
          totalStudyTime: 120,
          subjectsCovered: 5,
          tasksCompleted: 25,
          currentStreak: 7,
          subjectsTrend: 0,
          tasksTrend: 0,
          studyTimeTrend: 0
        });
      }
    };

    const fetchTasks = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/tasks`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        // Filter to only get upcoming tasks with a dueDate in the future
        const tasks = response.data.filter(task => {
          if (task.dueDate) {
            return new Date(task.dueDate) >= new Date();
          }
          return false;
        });
        setUpcomingTasks(tasks);
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    };

    fetchDashboardData();
    fetchTasks();
  }, []);

  return (
    <div className="dashboard">
      <h2>Study Dashboard</h2>
      
      <div className="dashboard-grid">
        <div className="stat-card">
          <h3>Total Study Time</h3>
          <div className="stat-value">
            {stats.totalStudyTime}h
          </div>
          <div className={`stat-trend ${stats.studyTimeTrend >= 0 ? 'trend-up' : 'trend-down'}`}>
            {stats.studyTimeTrend >= 0 ? <FaArrowUp /> : <FaArrowDown />} {Math.abs(stats.studyTimeTrend).toFixed(0)}% from last week
          </div>
          <FaClock className="stat-icon" />
        </div>

        <div className="stat-card">
          <h3>Subjects Covered</h3>
          <div className="stat-value">
            {stats.subjectsCovered}
          </div>
          <div className={`stat-trend ${stats.subjectsTrend >= 0 ? 'trend-up' : 'trend-down'}`}>
            {stats.subjectsTrend >= 0 ? <FaArrowUp /> : <FaArrowDown />} {Math.abs(stats.subjectsTrend)} {stats.subjectsTrend >= 0 ? 'new' : 'fewer'} this week
          </div>
          <FaBook className="stat-icon" />
        </div>

        <div className="stat-card">
          <h3>Tasks Completed</h3>
          <div className="stat-value">
            {stats.tasksCompleted}
          </div>
          <div className={`stat-trend ${stats.tasksTrend >= 0 ? 'trend-up' : 'trend-down'}`}>
            {stats.tasksTrend >= 0 ? <FaArrowUp /> : <FaArrowDown />} {Math.abs(stats.tasksTrend)} {stats.tasksTrend >= 0 ? 'new' : 'fewer'} this week
          </div>
          <FaCheckCircle className="stat-icon" />
        </div>

        <div className="stat-card">
          <h3>Current Streak</h3>
          <div className="stat-value">
            {stats.currentStreak} days
          </div>
          <div className="stat-trend trend-up">
            <FaArrowUp /> Keep it up!
          </div>
          <FaFire className="stat-icon" />
        </div>
      </div>

      <div className="dashboard-content">
        <div className="calendar-section">
          <h3>Study Calendar</h3>
          <Calendar
            onChange={setSelectedDate}
            value={selectedDate}
            className="dashboard-calendar"
          />
        </div>

        <div className="upcoming-tasks">
          <h3>Upcoming Tasks</h3>
          <div className="task-list">
            {upcomingTasks.map(task => (
              <div key={task.id} className="task-item">
                <div className="task-content">
                  <h4 className="task-title">{task.title}</h4>
                  <div className="task-meta">
                    <span>Due: {task.dueDate}</span>
                    <span className={`task-priority priority-${task.priority}`}>
                      {task.priority.charAt(0).toUpperCase() + task.priority.slice(1)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 